export class AuthService {
  static $inject = ['$http', '$log', '$q', 'Member'];

  private currentUser = null;

  constructor(
    private $http,
    private $log,
    private $q,
    private Member,
  ) { }

  login(credentials) {
    const deferred = this.$q.defer();

    this.$http.post('/api/auth', credentials).then(
      (authResult) => {
        this.setSession(authResult.data);
        deferred.resolve(true);
      },
      (error) => {
        this.$log.error(error);
        deferred.reject(error);
      },
    );

    return deferred.promise;
  }

  me() {
    const deferred = this.$q.defer();

    if (this.currentUser) {
      deferred.resolve(this.currentUser);
    } else {
      this.Member.me().then((user) => {
        this.currentUser = user;
        deferred.resolve(this.currentUser);
      });
    }
    return deferred.promise;
  }

  private setSession(authResult) {
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('expires_at', authResult.expiresAt);
  }

  logout() {
    this.currentUser = null;
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_at');
  }

  isAuthenticated() {
  // Check whether the current time is past the
  // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }
}
